import { combineReducers } from '@reduxjs/toolkit';

import { userApi, userReducer } from '@entities/user';
import { generationStateReducer } from '@entities/generation-state';
import { templateReducer } from '@entities/template';
import { employeeReducer } from '@entities/employee';

import { baseApi } from '@shared/api';
import { modalReducer } from '@shared/ui/modals';
import { countryReducer } from '@entities/country';
import { companyReducer } from '@entities/companies';
import { customerReducer } from '@entities/customers';
import { senderStateReducer } from '@entities/sender-state/model';
import { reportsSectionReducer } from '@pages/invoice-generator/shared/model';
import { invoiceGeneratorMenuReducer } from '@modules/invoice-generator/invoice-generator-menu/model';

export const rootReducer = combineReducers({
  user: userReducer,
  modal: modalReducer,
  employee: employeeReducer,
  country: countryReducer,
  invoiceGenerationState: generationStateReducer,
  emailSenderState: senderStateReducer,
  invoiceTemplate: templateReducer,
  company: companyReducer,
  customer: customerReducer,
  reportsSection: reportsSectionReducer,
  invoiceGeneratorMenu: invoiceGeneratorMenuReducer,
  [baseApi.reducerPath]: baseApi.reducer,
  [userApi.reducerPath]: userApi.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;
